import { useData } from "../../hooks/useData";
import Icon from "../Icon";
import { Reveal } from "../ui-custom/Reveal";

// Feature cards + animated vertical timeline.
export default function Features() {
  const { data } = useData("features");
  if (!data) return null;

  return (
    <div className="grid gap-14 lg:grid-cols-[1.15fr_0.85fr]">
      <div className="grid gap-4 sm:grid-cols-2">
        {data.items.map((f, i) => (
          <Reveal key={f.title} delay={(i % 2) * 0.08}>
            <div className="group h-full rounded-2xl glass p-5 transition-all duration-300 hover:-translate-y-1" data-testid={`feature-card-${i}`}>
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-soft text-brand-2 transition-transform duration-300 group-hover:scale-110">
                <Icon name={f.icon} size={20} />
              </div>
              <h4 className="mt-4 font-semibold text-slate-900">{f.title}</h4>
              <p className="mt-1.5 text-sm text-slate-500">{f.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="relative">
        <div className="absolute left-[19px] top-2 h-full w-px bg-gradient-to-b from-[color:var(--brand)] via-[color:var(--brand-2)] to-transparent opacity-40" />
        <div className="space-y-8">
          {data.timeline.map((t, i) => (
            <Reveal key={t.step} delay={i * 0.1} className="relative flex gap-5" data-testid={`timeline-${i}`}>
              <div className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full glass text-sm font-bold text-brand">
                {t.step}
              </div>
              <div>
                <h4 className="font-semibold text-slate-900">{t.title}</h4>
                <p className="mt-1 text-sm text-slate-500">{t.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
